module.exports = __webpack_public_path__ + "static/media/Selection Box Usage 700px.b392aaf3.gif";